import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { 
  Router,
  CanActivate,
  ActivatedRouteSnapshot
} from '@angular/router';
import { KitService } from 'src/shared/kit.service';

@Injectable()
export class GuardService implements CanActivate {
  constructor(
      public router: Router,
      private kitService: KitService,
      private readonly http: HttpClient,
      ) {}
  async canActivate(route: ActivatedRouteSnapshot) {
    const id = route.queryParams.id;
    if(id) {
        const preorder = await this.http
          .get<any>(
            "https://strapi.alkesoccer.com/preorders?id=" + id
          ).toPromise();
          this.kitService.setJson(preorder[0]);
          this.kitService.setStep("SUMMARY");
          
        return true;
    }

    if(this.kitService.getStep() == 'CHOOSE_CLOTHES') {
        this.router.navigate(['/']);
        return false;
    }    
    return true;
  }
}